import { useRequiredParams } from '@pba/react-router';
import { AppLayout } from 'layouts';
import { CommunityAssets, CommunityLayout } from 'features/communities-new';
import { ChangeRequestLogoutGuard } from '../change-request-logout-guard';
import { useCommunityInvitationTokenParams } from '../hooks';

type RouteParams = {
  communityId: string;
};

const PageCommunityAssets = () => {
  const { communityId } = useRequiredParams<RouteParams>();
  const { invitationToken } = useCommunityInvitationTokenParams();

  return (
    <AppLayout>
      <ChangeRequestLogoutGuard>
        <CommunityLayout communityId={communityId} invitationToken={invitationToken}>
          {(community) => <CommunityAssets community={community} />}
        </CommunityLayout>
      </ChangeRequestLogoutGuard>
    </AppLayout>
  );
};

export default PageCommunityAssets;
